import { Text } from '@consta/uikit/Text'
import { Tooltip } from '@consta/uikit/Tooltip'
import cn from 'classnames'
import { isDefined } from 'common/helpers'
import type { Nullable } from 'common/types'
import type { FC, MouseEventHandler, PropsWithChildren } from 'react'
import { useRef, useState } from 'react'

import css from '../Legend.css'
import type { HeaderProps } from '../types'

const DEFAULT_TITLE = 'Объект не выбран/не визуализируется на сцене'

const LegendHeader: FC<PropsWithChildren<HeaderProps>> = ({ children, className }) => {
  const headerRef = useRef<Nullable<HTMLDivElement>>(null)
  const [showTooltip, setShowTooltip] = useState(false)

  const toggleShowTooltip: MouseEventHandler = event => {
    event.stopPropagation()
    setShowTooltip(prev => !prev)
  }

  const isDefinedChildren = isDefined(children)
  const headerClassName = cn(className, css.headerText, {
    [css.isDefined]: isDefinedChildren,
  })

  return (
    <div
      ref={headerRef}
      className={headerClassName}
      onMouseEnter={toggleShowTooltip}
      onMouseLeave={toggleShowTooltip}>
      {isDefinedChildren ? children : DEFAULT_TITLE}
      <Tooltip isOpen={showTooltip} direction="leftCenter" anchorRef={headerRef}>
        <Text size="xs" view="primary" className={css.headerTooltipText}>
          {isDefinedChildren ? children : DEFAULT_TITLE}
        </Text>
      </Tooltip>
    </div>
  )
}

const TextBlock: FC<PropsWithChildren<{ textColor?: string }>> = ({ children, textColor }) => {
  const style = {
    color: textColor,
  }

  return (
    <span className={css.headerTextBlock} style={style}>
      {children}
    </span>
  )
}

export const Header = Object.assign(LegendHeader, {
  TextBlock,
})
